import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ImageWrapper as CompiledImageWrapper } from './ImageWrapper-compiled';
import { ImageWrapper as EmotionImageWrapper } from './ImageWrapper-emotion';
export var ImageWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledImageWrapper, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(EmotionImageWrapper, _extends({}, props, {
    ref: ref
  }));
});